import Swiper, {Pagination, Navigation} from 'swiper';
import VideoHls from "../components/video-hls";

class LookSlider {

    loading = false;
    instance: Swiper;
    private interval = [];
    private hoverTimer: NodeJS.Timeout;

    constructor() {
        const instance = new Swiper('.look--slider', {
            modules: [Pagination, Navigation],
            loop: false,
            grabCursor: true,
            slidesPerView: 'auto',
            spaceBetween: 0,
            pagination: {
                el: document.querySelector<HTMLElement>(".look--nav-block .swiper-pagination"),
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 1,
                bulletActiveClass: "_active",
                renderBullet: (index, className) => {
                    return `<div class="look--nav__item ${className}"></div>`;
                }
            },
            navigation: {
                disabledClass: '_disabled',
                nextEl: '.look--slider-btn__next',
                prevEl: '.look--slider-btn__prev',
            },
            on: {
                afterInit: function () {
                    let currentSlide;
                    if (window.outerWidth <= 575) {
                        currentSlide = document.querySelector('#look .swiper-slide.swiper-slide-active');
                    } else {
                        currentSlide = document.querySelector('#look .swiper-slide.swiper-slide-next');
                    }
                    const backgroundImgCurrent = document.querySelector('.look--background__img_' + currentSlide.dataset.slideId);
                    backgroundImgCurrent?.classList.add('_active');
                },
                slideChangeTransitionEnd: function () {
                    let nextSlide;
                    if (window.outerWidth <= 575) {
                        nextSlide = this.slides[this.activeIndex];
                    } else {
                        nextSlide = this.slides[this.activeIndex + 1];
                    }
                    const backgroundImgActive = document.querySelector('.look--background__img._active');
                    const backgroundImgCurrent = document.querySelector('.look--background__img_' + nextSlide.dataset.slideId);
                    backgroundImgActive.classList.remove('_active');
                    backgroundImgCurrent.classList.add('_active');
                }
            },
        })

        Array.from(instance.slides).forEach(
            slide => {
                slide.addEventListener('mouseover', () => {
                    if (window.outerWidth >= 576) {
                        const currentSlide = slide as HTMLElement;
                        const backgroundImgActive = document.querySelector('.look--background__img._active') as HTMLElement;
                        const backgroundImgCurrent = document.querySelector('.look--background__img_' + currentSlide.dataset.slideId) as HTMLElement;
                        if (currentSlide?.dataset.slideId != backgroundImgActive?.dataset.slideId) {
                            backgroundImgActive?.classList.remove('_active');
                            backgroundImgCurrent?.classList.add('_active');
                        }
                    }

                    this.hoverTimer = setTimeout(() => {
                        this.startVideo(slide, instance);
                    }, 1000);
                })
                slide.addEventListener('mouseout', () => {
                    if (window.outerWidth >= 576) {
                        const currentSlide = document.querySelector('#look .swiper-slide.swiper-slide-next') as HTMLElement;
                        const backgroundImgActive = document.querySelector('.look--background__img._active') as HTMLElement;
                        const backgroundImgCurrent = document.querySelector('.look--background__img_' + currentSlide.dataset.slideId) as HTMLElement;
                        if (currentSlide?.dataset.slideId != backgroundImgActive?.dataset.slideId) {
                            backgroundImgActive?.classList.remove('_active');
                            backgroundImgCurrent?.classList.add('_active');
                        }
                    }

                    clearTimeout(this.hoverTimer);
                    setTimeout(() => {
                        this.destroy();
                    }, 1000)
                })
            }
        );
    }

    destroy() {
        if (this.interval.length) {
            this.interval.forEach(i => {
                clearTimeout(i)
            })

            this.interval = [];
        }

        let previousSlide = document.querySelectorAll('.look--slider__img');

        Array.from(previousSlide).forEach((e: HTMLElement) => {
            e.classList.remove('loaded');
            if (e.querySelector('.plyr'))
                e.querySelector('.plyr').remove();
            if (e.querySelector('.youtube-player'))
                e.querySelector('.youtube-player').remove();
            if (e.querySelector('video'))
                e.querySelector('video').remove();
        })
    }

    startVideo(currentElement, swiper) {

        this.destroy();

        let currentSlide = currentElement.querySelector('.look--slider__img');
        if (currentSlide) {
            new VideoHls(currentSlide, {
                loop: false,
                onPlayStart: (videoHls) => {
                    let startTime = typeof currentSlide.dataset.videoStart !== 'undefined' ? currentSlide.dataset.videoStart : 0;

                    if (startTime)
                        videoHls.player.forward(startTime)

                    this.interval.push(setTimeout(() => {
                        swiper.slideNext();
                    }, 15000))

                },
                onEnded: () => {
                    swiper.slideNext();
                }
            });

        }
    }

    onSlideChange(swiper) {
        let currentElement = swiper.slides[swiper.activeIndex]
        this.startVideo(currentElement, swiper);
    }
}

export default LookSlider;
